import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconPasteStyle0 = cosmosIconCss;

const CosmosIconPaste$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconPaste extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'a4f71117683c6cf98f8f6355a439173ea87189ba', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '6c4c001d23d457af127b98b091591cf863852874', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'd4554861363d2fddf602c39e3d91af9174a78e18', d: "M10.5 3.5A.5.5 0 0 1 11 3h3a.5.5 0 0 1 .5.5V4H17a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5V15a.5.5 0 0 1 .5-.5h1v-9H9v1a.5.5 0 0 1-.5.5H8a.5.5 0 0 1-.5-.5v-2A.5.5 0 0 1 8 4h2.5v-.5Z", fill: "currentColor" }), h("path", { key: '5d2cbe53fd0504748b42a892bb73016bff82879f', d: "M4.5 8.5A.5.5 0 0 1 5 8h8a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5H5a.5.5 0 0 1-.5-.5v-10Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconPasteStyle0; }
}, [1, "cosmos-icon-paste", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-paste"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-paste":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconPaste$1);
            }
            break;
    } });
}

const CosmosIconPaste = CosmosIconPaste$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconPaste, defineCustomElement };
